import Head from "next/head";
import LoadingAnimation from "./LoadingAnimation";

const LoadingPage = ({
  title: title = "Moongate",
  children,
  size: size = 48,
}: {
  title?: string;
  children?: any;
  size?: number;
}) => {
  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <div className="flex flex-col content-center justify-center items-center h-screen w-screen z-100">
        <LoadingAnimation size={size} />
        {children}
      </div>
    </>
  );
};

export default LoadingPage;
